// Cambia esta única variable para que TODOS los microservicios apunten a local o a producción.
const USE_LOCAL = false;

const BASES = {
    client: USE_LOCAL ? 'http://localhost:5001/api/client/' : 'https://crmcliente.biccrm.com/api/client/',
    usuario: USE_LOCAL ? 'http://localhost:5004/api/usuario/' : 'https://crmusuario.biccrm.com/api/usuario/',
    almacenes: USE_LOCAL ? 'http://localhost:5006/api/almacenes/' : 'https://crmalmacen.biccrm.com/api/almacenes/',
    estadisticas: USE_LOCAL ? 'http://localhost:5007/api/estadisticas/' : 'https://crmestadistica.biccrm.com/api/estadisticas/',
    notificacion: USE_LOCAL ? 'http://localhost:5003/api/notifications/' : 'https://crmnotifications.biccrm.com/api/notifications/',
    facturas: USE_LOCAL ? 'http://localhost:5005/api/facturas/' : 'https://crmfacturas.biccrm.com/api/facturas/',
    admin: USE_LOCAL ? 'http://localhost:5008/api/admin/' : 'https://crmadmin.biccrm.com/api/admin/',
    cupon: USE_LOCAL ? 'http://localhost:5008/api/admin/cupon/' : 'https://crmadmin.biccrm.com/api/admin/cupon/',
    solicitudes: USE_LOCAL ? 'http://localhost:5010/api/solicitudes/' : 'https://crmsolicitud.biccrm.com/api/solicitudes/',
};

export const ROUTES_CONFIG = {
    client:{
        base:BASES.client,
        endpoints:{
            get:'',
            getByDocument:'findOne',
            saveEntradaVisitantes:'saveEntradaVisitantes',
            getCanalAtencion:'getCanalAtencion',
            getTipoFpqrs:'getTipoFpqrs',
            getCategoriaFpqrs:'getCategoriaFpqrs',
            getArea:'getArea',
            getTipoDocumento:'getTipoDocumento',
            getCiudad:'getCiudad',
            getBarrio:'getBarrio',
            getMotivoSolicitud:'getMotivoSolicitud',
            insertOrEditFpqrs:'insertOEditFpqrs',
            getFpqrs:'getFpqrs',
            getFilesFpqrs:'getFilesFpqrs',
            getReferencias:'getReferencias',
            listTiposReferencia:'listTiposReferencia',
            listReferenciasPorTipo:'listReferenciasPorTipo',
            insertOrEditReferencia:'insertOrEditReferencia',
            insertOrEditClient:'insertOrEditClient',
            getClient:'getClient',
            getClienteDetalle:'getClienteDetalle',
            desuscribir:'desuscribir',
            listNoSuscritos:'listNoSuscritos',
            resuscribirCliente:'resuscribirCliente',
            getComercial:'getComercial',
            getPiso:'getPiso',
            getPlazoleta:'getPlazoleta',
            getTipoStand:'getTipoStand',
            insertOrEditStand:'insertOrEditStand',
            insertOrEditQuoteComercial:'insertOrEditQuoteComercial',
            asambleaFirma:'asambleaFirma',
            searchAsambleistas:'searchAsambleistas'
        }
    },
    usuario:{
        base:BASES.usuario,
        endpoints:{
            login:'login',
            listUsuarios:'listUsuarios',
            assignRolUsuario:'assignRolUsuario',
            insertOrEditUsuario:'insertOrEditUsuario'
        }
    },
    almacenes:{
        base:BASES.almacenes,
        endpoints:{
            getHorarioAlmacenes:'findAll',
            updateHorarioAlmacen:'updateHorarioAlmacen',
            getImagenHorarioAlmacen:'imagenHorarioAlmacen',
            getAlmacenes:'getAlmacenes',
            getAlmacen:'getAlmacen',
            insertAlmacen:'insertAlmacen',
            updateAlmacen:'updateAlmacen',
            insertHorarioAlmacen:'inserHorarioAlmacen',
            deleteHorarioAlmacen:'deleteHorarioAlmacen'
        }
    },
    estadisticas:{
        base:BASES.estadisticas,
        endpoints:{
            getReferencia:'referencia',
            getTipoCliente:'tipoCliente',
            getTipoGrupo:'tipoGrupo',
            getSorteos:'sorteos',
            estadistiscaSigma:'estadistiscaSigma',
            createListContact:'createListContact',
            getListContact:'getListContact',
            getCategory:'getCategory',
            deleteListContact:'deleteListContact',
            reenviarListaContacto:'reenviarListaContacto',
            // BILG Analytics
            bilgAniosDisponibles:'bilg/aniosDisponibles',
            bilgKpis:'bilg/kpis',
            bilgVentasMensual:'bilg/ventasMensual',
            bilgMediosPago:'bilg/mediosPago',
            bilgTopAlmacenes:'bilg/topAlmacenes',
            bilgNuevosClientes:'bilg/nuevosClientes',
            bilgTicketMensual:'bilg/ticketMensual',
            bilgDiasSemana:'bilg/diasSemana',
            bilgDemografia:'bilg/demografia',
            bilgClientesListado:'bilg/clientes',
            bilgGeneraciones:'bilg/generaciones',
            bilgAlmacenes:'bilg/almacenes',
            bilgOcupacionKpis:'bilg/ocupacionKpis',
            bilgOcupacionTipo:'bilg/ocupacionTipo',
            bilgOcupacionCategoria:'bilg/ocupacionCategoria',
            bilgAnalisisGerencial:'bilg/analisisGerencial',
            bilgCatalogos:'bilg/catalogos',
            bilgVentasDiarias:'bilg/ventasDiarias',
            bilgAnalisisVentas:'bilg/analisisVentas',
            bilgInteligenciaEstrategica:'bilg/inteligenciaEstrategica',
            bilgProyecciones:'bilg/proyecciones',
            bilgInsightsPremium:'bilg/insightsPremium',
            bilgRfm:'bilg/rfm',
            // Territorial
            bilgTerritorialResumen:      'bilg/territorial/resumen',
            bilgTerritorialLocalidades:  'bilg/territorial/localidades',
            bilgTerritorialBarrios:      'bilg/territorial/barrios',
            bilgTerritorialEstratos:     'bilg/territorial/estratos',
            bilgTerritorialEvolucion:    'bilg/territorial/evolucion',
            bilgTerritorialCalidadDatos: 'bilg/territorial/calidadDatos',
            // Sorteos / Campañas
            bilgSorteosCampanias:      'bilg/sorteos/campanias',
            bilgSorteosResumen:        'bilg/sorteos/resumen',
            bilgSorteosDemografia:     'bilg/sorteos/demografia',
            bilgSorteosSocial:         'bilg/sorteos/social',
            bilgSorteosFamilia:        'bilg/sorteos/familia',
            bilgSorteosSocioeconomico: 'bilg/sorteos/socioeconomico',
            bilgSorteosRfm:            'bilg/sorteos/rfm',
            bilgSorteosActividad:      'bilg/sorteos/actividad',
            // Eventos / Campañas — lista desde FacturasService (getListeventosBilg)
            bilgEventosResumen:        'bilg/eventos/resumen',
            bilgEventosDemografia:     'bilg/eventos/demografia',
            bilgEventosSocial:         'bilg/eventos/social',
            bilgEventosFamilia:        'bilg/eventos/familia',
            bilgEventosSocioeconomico: 'bilg/eventos/socioeconomico',
            bilgEventosRfm:            'bilg/eventos/rfm',
            bilgEventosActividad:      'bilg/eventos/actividad',
            // Premios entregados
            bilgPremiosResumen:        'bilg/premios/resumen',
            bilgPuntosRedimidos:       'bilg/puntosRedimidos',
        }
    },
    notificacion:{
        base:BASES.notificacion,
        endpoints:{
            sendEmail:'',
            test:'test'
        }
    },
    facturas:{
        base:BASES.facturas,
        endpoints:{
            ocr:'ocr',
            preCreateBillOcr:'preCreateBillOcr',
            registrarFacturasOcrBatch:'registrarFacturasOcrBatch',
            ocrJumpCube:'ocrJumpCube',
            getBillsOcrPending:'getBillsOcrPending',
            createBill:'createBill',
            getInfoBenchMarking:'getInfoBenchMarking',
            getVirtualBill:'getVirtualBill',
            getPremiosEntregar:'getPremiosEntregar',
            getRuletaActiva:'getRuletaActiva',
            selectGift:'selectGift',
            consultTickets:'consultTickets',
            sendEmailTicket:'sendEmailTicket',
            getListeventosBilg:'getListeventosBilg',
            registrarFacturaManual:'registrarFacturaManual',
            registrarFacturasManualBatch:'registrarFacturasManualBatch',
            listFacturasCliente:'listFacturasCliente',
            listAcumuladosCliente:'listAcumuladosCliente',
            eliminarFacturaManual:'eliminarFacturaManual',
            reimprimirFactura:'reimprimirFactura',
            generarBoletaPdf:'generarBoletaPdf',
            generarBoletaEventoPdf:'generarBoletaEventoPdf',
            existeFactura:'existeFactura',
            registrarParqueo:'registrarParqueo',
            listPlantillasBoleta:'listPlantillasBoleta',
            insertOrEditPlantillaBoleta:'insertOrEditPlantillaBoleta',
            deletePlantillaBoleta:'deletePlantillaBoleta',
            listSorteosActivos:'listSorteosActivos',
            listEventosActivos:'listEventosActivos',
            listSorteosActivosDetalle:'listSorteosActivosDetalle',
            revisarBoletasSorteo:'revisarBoletasSorteo'
        }
    },
    admin:{
        base:BASES.admin,
        endpoints:{
            insertOrEditTemplate:'insertOrEditTemplate',
            listTemplate:'listTemplate',
            uploadImagenPlantilla:'uploadImagenPlantilla',
            insertOrEditModulo:'insertOrEditModulo',
            listModulos:'listModulos',
            insertOrEditRol:'insertOrEditRol',
            listRoles:'listRoles',
            insertOrEditAccion:'insertOrEditAccion',
            listAcciones:'listAcciones',
            insertOrEditTipoReclamo:'insertOrEditTipoReclamo',
            listTipoReclamo:'listTipoReclamo',
            insertOrEditTipoArea:'insertOrEditTipoArea',
            listTipoArea:'listTipoArea',
            insertOrEditPuntoAtencion:'insertOrEditPuntoAtencion',
            listPuntoAtencion:'listPuntoAtencion',
            insertOrEditMotivoSolicitudes:'insertOrEditMotivoSolicitudes',
            listMotivoSolicitudes:'listMotivoSolicitudes',
            insertOrEditMotivo:'insertOrEditMotivos',
            listMotivos:'listMotivos',
            getTipoNegocio:'getTipoNegocio',
            getSubTipoNegocio:'getSubTipoNegocio',
            listRolesModulos:'listRolesModulos',
            insertOrEditRolesModulos:'insertOrEditRolesModulos',
            listModulosCentroComercial:'listModulosCentroComercial',
            insertOrEditModulosCentroComercial:'insertOrEditModulosCentroComercial',
            listCentroComercial:'listCentroComercial',
            insertOrEditCentroComercial:'insertOrEditCentroComercial',
            listConfiguracionCorreo:'listConfiguracionCorreo',
            insertOrEditConfiguracionCorreo:'insertOrEditConfiguracionCorreo',
            deleteConfiguracionCorreo:'deleteConfiguracionCorreo',
            copyConfiguracionCorreo:'copyConfiguracionCorreo',
            listCorreoEnvioLog:'listCorreoEnvioLog',
            statsEnviosMasivos:'statsEnviosMasivos',
            listParametroHorarioContacto:'listParametroHorarioContacto',
            guardarParametroHorarioContacto:'guardarParametroHorarioContacto',
            listFestivos:'listFestivos',
            insertOrEditFestivo:'insertOrEditFestivo',
            deleteFestivo:'deleteFestivo',
            listPremiosAEntregar:'listPremiosAEntregar',
            insertOrEditPremiosAEntregar:'insertOrEditPremiosAEntregar',
            ajustarStockPremiosAEntregar:'ajustarStockPremiosAEntregar',
            deletePremiosAEntregar:'deletePremiosAEntregar',
            getPremioImagen:'getPremioImagen',
            listRuleta:'listRuleta',
            getRuletaImagenes:'getRuletaImagenes',
            insertOrEditRuleta:'insertOrEditRuleta',
            deleteRuleta:'deleteRuleta',
            listAlmacenSorteo:'listAlmacenSorteo',
            insertAlmacenSorteo:'insertAlmacenSorteo',
            deleteAlmacenSorteo:'deleteAlmacenSorteo',
            listPremiosEntregados:'listPremiosEntregados',
            listCategorias:'listCategorias',
            insertOrEditCategoria:'insertOrEditCategoria',
            deleteCategoria:'deleteCategoria',
            listPremiosFidelizacion:'listPremiosFidelizacion',
            insertOrEditPremioFidelizacion:'insertOrEditPremioFidelizacion',
            deletePremioFidelizacion:'deletePremioFidelizacion',
            listEventos:'listEventos',
            insertOrEditEvento:'insertOrEditEvento',
            deleteEvento:'deleteEvento',
            listAlmacenSorteoPremio:'listAlmacenSorteoPremio',
            insertAlmacenSorteoPremio:'insertAlmacenSorteoPremio',
            deleteAlmacenSorteoPremio:'deleteAlmacenSorteoPremio',
            listDetalleSorteo:'listDetalleSorteo',
            listSorteoDiaSemana:'listSorteoDiaSemana',
            agregarGanadorSorteoPorDocumento:'agregarGanadorSorteoPorDocumento',
            recalcularRfm:'recalcularRfm',
            listSaldoClientes:'listSaldoClientes',
            ajustarSaldoCliente:'ajustarSaldoCliente',
            listBoletas:'listBoletas',
            listFacturasEliminadas:'listFacturasEliminadas',
            marcarGanadorBoleta:'marcarGanadorBoleta',
            listRankingPuntos:'listRankingPuntos',
            listRestriccionesGanadores:'listRestriccionesGanadores',
            insertRestriccionGanador:'insertRestriccionGanador',
            eliminarRestriccionGanador:'eliminarRestriccionGanador',
            aplicarRestriccionesGanadores:'aplicarRestriccionesGanadores',
            listClientesDuplicados:'listClientesDuplicados',
            fusionarClientes:'fusionarClientes',
            listNovedades:'listNovedades',
            getNovedad:'getNovedad',
            insertNovedad:'insertNovedad',
            responderNovedad:'responderNovedad',
            listEquipos:'listEquipos',
            insertOrEditEquipo:'insertOrEditEquipo',
            deleteEquipo:'deleteEquipo',
            listPrestamosEquipos:'listPrestamosEquipos',
            insertPrestamoEquipo:'insertPrestamoEquipo',
            devolverPrestamoEquipo:'devolverPrestamoEquipo',
            cambiarEquipoPrestamo:'cambiarEquipoPrestamo',
            importarGoPass:'importarGoPass',
            listGoPass:'listGoPass',
            getClienteVista360:'getClienteVista360',
            listFamiliaresCliente:'listFamiliaresCliente',
            listPuntosCliente:'listPuntosCliente',
            listPremiosDisponibles:'listPremiosDisponibles',
            listPremiosRedimidosCliente:'listPremiosRedimidosCliente',
            redimirPremioCliente:'redimirPremioCliente',
            listCampanasPuntos:'listCampanasPuntos',
            insertOrEditCampanaPuntos:'insertOrEditCampanaPuntos',
            deleteCampanaPuntos:'deleteCampanaPuntos',
            listPremiosCampana:'listPremiosCampana',
            insertOrEditPremioCampana:'insertOrEditPremioCampana',
            deletePremioCampana:'deletePremioCampana',
            insertFamiliarCliente:'insertFamiliarCliente',
            updateFamiliarCliente:'updateFamiliarCliente',
            deleteFamiliarCliente:'deleteFamiliarCliente',
            listMascotasCliente:'listMascotasCliente',
            insertMascotaCliente:'insertMascotaCliente',
            updateMascotaCliente:'updateMascotaCliente',
            deleteMascotaCliente:'deleteMascotaCliente',
            getProductosReciclables:'getProductosReciclables',
            listClienteReciclaje:'listClienteReciclaje',
            insertClienteReciclaje:'insertClienteReciclaje',
            updateClienteReciclaje:'updateClienteReciclaje',
            deleteClienteReciclaje:'deleteClienteReciclaje',
            getAcumuladoReciclaje:'getAcumuladoReciclaje',
            listTalleresCliente:'listTalleresCliente',
            insertTallerCliente:'insertTallerCliente',
            updateTallerCliente:'updateTallerCliente',
            entregarKitTaller:'entregarKitTaller',
            deleteTallerCliente:'deleteTallerCliente',
            listActividades:'listActividades',
            insertActividad:'insertActividad',
            reenviarCorreoBoleta:'reenviarCorreoBoleta'
        }
    },
    cupon:{
        base:BASES.cupon,
        endpoints:{
            getCupones:'getCupones',
            obtenerCupon:'obtenerCupon',
            validarCupon:'validarCupon',
            redimirCupon:'redimirCupon',
            listCupones:'listCupones',
            insertOrEditCupon:'insertOrEditCupon',
            deleteCupon:'deleteCupon',
            listEmisiones:'listEmisiones',
            getMisCupones:'getMisCupones',
            getAnalyticsCupon:'getAnalyticsCupon',
            buscarCliente:'buscarCliente',
            aplicarCuponPublico:'aplicarCuponPublico',
        }
    },
    solicitudes:{
        base:BASES.solicitudes,
        endpoints:{
            getAreas:'getAreas',
            crearArea:'crearArea',
            actualizarArea:'actualizarArea',
            getCategorias:'getCategorias',
            crearCategoria:'crearCategoria',
            actualizarCategoria:'actualizarCategoria',
            getTiposSolicitud:'getTiposSolicitud',
            crearTipoSolicitud:'crearTipoSolicitud',
            actualizarTipoSolicitud:'actualizarTipoSolicitud',
            getDefinicionActivaTipo:'getDefinicionActivaTipo',
            getDefinicionTipoPorId:'getDefinicionTipoPorId',
            listarDefinicionesTipo:'listarDefinicionesTipo',
            obtenerOCrearBorradorDefinicionTipo:'obtenerOCrearBorradorDefinicionTipo',
            actualizarBorradorDefinicionTipo:'actualizarBorradorDefinicionTipo',
            publicarBorradorDefinicionTipo:'publicarBorradorDefinicionTipo',
            getFlujosAprobacion:'getFlujosAprobacion',
            crearFlujoAprobacion:'crearFlujoAprobacion',
            getDefinicionFlujoPorId:'getDefinicionFlujoPorId',
            listarDefinicionesFlujo:'listarDefinicionesFlujo',
            obtenerOCrearBorradorFlujo:'obtenerOCrearBorradorFlujo',
            actualizarBorradorFlujo:'actualizarBorradorFlujo',
            publicarBorradorFlujo:'publicarBorradorFlujo',
            getContactoPorEmail:'getContactoPorEmail',
            crearContacto:'crearContacto',
            getAccesosContacto:'getAccesosContacto',
            getAlmacenesDelContacto:'getAlmacenesDelContacto',
            otorgarAccesoContacto:'otorgarAccesoContacto',
            listarSolicitudes:'listarSolicitudes',
            listarSolicitudesPorContacto:'listarSolicitudesPorContacto',
            getSolicitudPorId:'getSolicitudPorId',
            crearBorradorSolicitud:'crearBorradorSolicitud',
            actualizarSolicitud:'actualizarSolicitud',
            registrarCambioEstado:'registrarCambioEstado',
            getHistorialEstado:'getHistorialEstado',
            getRespuestas:'getRespuestas',
            guardarRespuestas:'guardarRespuestas',
            getAdjuntos:'getAdjuntos',
            agregarAdjunto:'agregarAdjunto',
            getComentarios:'getComentarios',
            agregarComentario:'agregarComentario',
            getNotasInternas:'getNotasInternas',
            agregarNotaInterna:'agregarNotaInterna',
            getAsignaciones:'getAsignaciones',
            crearAsignacion:'crearAsignacion',
            getInstanciaAprobacion:'getInstanciaAprobacion',
            crearInstanciaAprobacion:'crearInstanciaAprobacion',
            actualizarInstanciaAprobacion:'actualizarInstanciaAprobacion',
            getAccionesAprobacion:'getAccionesAprobacion',
            registrarAccionAprobacion:'registrarAccionAprobacion',
            subirAdjunto:'subirAdjunto',
            obtenerAdjunto:'obtenerAdjunto',
            solicitarOtp:'solicitarOtp',
            verificarOtp:'verificarOtp',
            getContratistas:'getContratistas',
            crearContratista:'crearContratista',
            actualizarContratista:'actualizarContratista',
            getPersonas:'getPersonas',
            crearPersona:'crearPersona',
            actualizarPersona:'actualizarPersona',
            getVehiculos:'getVehiculos',
            crearVehiculo:'crearVehiculo',
            actualizarVehiculo:'actualizarVehiculo',
            getPersonasVinculadas:'getPersonasVinculadas',
            vincularPersona:'vincularPersona',
            desvincularPersona:'desvincularPersona',
            getVehiculosVinculados:'getVehiculosVinculados',
            vincularVehiculo:'vincularVehiculo',
            desvincularVehiculo:'desvincularVehiculo',
            getActividadesPorSolicitud:'getActividadesPorSolicitud',
            getActividadesPorMall:'getActividadesPorMall',
            crearActividad:'crearActividad',
            actualizarEstadoActividad:'actualizarEstadoActividad',
            crearAutorizacionQr:'crearAutorizacionQr',
            getAutorizacionesPorSolicitud:'getAutorizacionesPorSolicitud',
            getAutorizacionPorToken:'getAutorizacionPorToken',
            revocarAutorizacionQr:'revocarAutorizacionQr',
            crearNotificacion:'crearNotificacion',
            listarNotificaciones:'listarNotificaciones',
            marcarNotificacionLeida:'marcarNotificacionLeida',
            contarNotificacionesNoLeidas:'contarNotificacionesNoLeidas',
            listarAuditoria:'listarAuditoria',
        }
    }
};